import React from "react";
import Loading from "../../assets/loading.gif";
const Spinner = (props: { big?: boolean }) => {
  return (
    <div className="loader-component py-1">
      <img
        src={Loading}
        className={`${props.big === true ? "w-28" : "w-10"} mx-auto`}
        alt=""
      />
    </div>
  );
};

export default Spinner;
